import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';
import { ChangeWallMaterial } from "./changeWallMaterial";
export class ChangePointOutWall extends ChangeWallMaterial {

    constructor(wall: THREE.Object3D) {
        super(wall);
    }

    protected getTexture(index: number): THREE.Texture {
        return ThreeView.get().matmgr.me.materials().wallTexes[index];
    }

    protected isWallType = (name: string): boolean => {
        return name.match(/^out.*-wall.*-node/) != null;
    }

    protected side(): number {
        return 1;           //外壁
    }
}
